module.exports = __webpack_public_path__ + "media/drumroll.e364278e.mp3";